// REACT IMPORTS
import React, { useEffect, useRef, useState } from "react";

// COMPONENT IMPORTS
import PaymentMethodsComponent from "components/paymentMethod/PaymentMethodsComponent";
import expiryDateValidation, {
  checkBankManualFormOrPlaid,
  checkNewPaymentDetails,
  checkOldPaymentDetails,
  checkOverPaymentAmount,
  formatCurrency,
  formatExpirationDate,
  getBankName,
  getCardType,
  getMethod,
  getMethodCode,
  getOperatingSystem,
  validateCard,
} from "utils/HelperFunctions";
import Button from "components/form/Button";
import PaymentProcessStep2 from "pages/payments/PaymentProcessStep2";
import {
  oldPaymentMethodsGet,
  useHasLoadedPaymentMethods,
  useBankData,
  useCardData,
  useOldWalletData,
} from "store/slices/paymentMethodSlice";
import { AddCircleIconBlue } from "utils/icon";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { addNotification, useUserData } from "store/slices/authSlice";
import {
  useLeadData,
  usePortalSettingsData,
} from "store/slices/dashboardSlice";
import {
  onSetFinalDisclosureLoading,
  onSetShowDisclosure,
  updateCheckAmountState,
  updateShowOverlayState,
  useIsLogin,
  useShowFinalDisclosure,
} from "store/slices/commonSlice";
import {
  convFeeGet,
  duplicatePaymentGet,
  getpaymentPermission,
  resetCheckDuplicatePayment,
  resetConvFee,
  resetDuplicateOrder,
  verifyWalletPay,
  setIsPaymentProcessing,
  markIncompletePayment,
  verifyPaymentsViaStax,
} from "store/slices/paymentsSlice";
import {
  getPaymentTotalWithFee,
  hasValidPaymentPrincipal,
} from "utils/paymentFee";
import { useParams } from "react-router-dom";
import DisclosureFinal from "./DisclosureFinal";
import { decode } from "utils/HelperFunctions";
import {
  FormRef,
  OverPaymentProtectionEnum,
  PaymentGateway,
  PaymentMethodList,
  SettingsValue,
} from "types/payments";
import { valuesProps } from "types/paymentMethods";
import CustomModal from "components/ui-component/CustomModal";
import { RootState } from "store/store";
import {
  VerifyStaxCardPaymentParams,
  VerifyStripeCardPaymentParams,
} from "types/agreement";
import { useDefaultPaymentMethodView } from "hooks/useDefaultPaymentMethodView";

/* ------------------------------------- MAKE PAYMENT PAGE ------------------------------------- */

type OneTimePaymentProps = {
  editVal?: string;
  selectedMethod: string;
  setSelectedMethod: (val: string) => void;
  isPaymentLink?: boolean;
  createNewCard: (values: any) => void;
  dataPayment: any;
  setDataPayment: any;
  setCurrentStep: (val: number) => void;
  isDataLoading?: boolean;
  setSavedCardsEmail: any;
  savedCardsEmail: string;
  isAddNewCard: boolean;
  currentStep: number;
  handleNext: any;
  offerAmount?: string;
  offerType?: string;
  vdcId?: number;
  schedulePayment?: boolean;
  dataArr?: any;
  isEdit?: boolean;
  isGoogleLoading?: boolean;
  handleGooglePay: any;
  handleApplePay: any;
  createPayPalIntent: any;
  paymentMethodList: PaymentMethodList[];
  setIsAddNewCard: (val: boolean) => void;
  setAmtErr?: any;
  setIsEdit?: any;
  amtErr?: any;
  isUpdatePlan?: boolean;
  handlePrev?: any;
  setShowPreview?: any;
  values: valuesProps;
  setValues: any;
  generalMarkers?: { [key: string]: string };
  isManualForm?: boolean;
  setIsManualForm?: any;
  setIsGoogleLoading: (val: boolean) => void;
  setPaymentProcess: (val: string) => void;
  sendEmail: (val: any) => Promise<void>;
  setFailedReason: (val: any) => void;
  setAmount: (val: string) => void;
  setInvoiceId: (val: string) => void;
  setEmailDisplay: (val: string) => void;
};

const OneTimePayment = (props: OneTimePaymentProps) => {
  const {
    editVal = "",
    handleNext = () => {},
    isPaymentLink = false,
    createNewCard,
    dataPayment,
    setDataPayment,
    setCurrentStep,
    isDataLoading,
    setSavedCardsEmail,
    savedCardsEmail,
    isAddNewCard,
    currentStep,
    offerAmount = "",
    offerType,
    vdcId,
    schedulePayment = false,
    dataArr,
    isEdit = false,
    handleGooglePay = null,
    createPayPalIntent,
    isGoogleLoading = false,
    paymentMethodList,
    setIsAddNewCard,
    handleApplePay = () => {},
    setAmtErr = () => {},
    setPaymentProcess = () => {},
    sendEmail = () => {},
    setFailedReason = () => {},
    setAmount = () => {},
    setInvoiceId = () => {},
    amtErr = null,
    isUpdatePlan = false,
    handlePrev = () => {},
    selectedMethod,
    setSelectedMethod,
    setShowPreview,
    values,
    setValues,
    generalMarkers = { "": "" },
    isManualForm = true,
    setIsManualForm = () => {},
    setIsGoogleLoading,
    setEmailDisplay = () => {},
  } = props;
  const offerCallbackQuery =
    offerType && vdcId
      ? `&offer_type=${encodeURIComponent(offerType)}&vdc_id=${vdcId}`
      : "";
  const offerPayload =
    offerType && vdcId ? { offer_type: offerType, vdc_id: vdcId } : {};
  const portalSettings = usePortalSettingsData();
  const cardList = useCardData();
  const bankList = useBankData();
  const hasLoadedPaymentMethods = useHasLoadedPaymentMethods();
  const userData = useUserData();
  const walletList = useOldWalletData();
  const accountLeadData = useLeadData();
  const isLogin = useIsLogin();
  const dispatch = useAppDispatch();

  const showFinalDisclosure = useShowFinalDisclosure();
  const disclosureContainerRef = useRef<HTMLDivElement>(null);
  const pendingDisclosureScrollRef = useRef<boolean>(false);

  const { clusterId: cluster_id } = useParams();
  const clusterId = decode(cluster_id || "", true);
  const cashAppRef = useRef<FormRef>(null);
  const bankRef = useRef<FormRef>(null);
  const cardRef = useRef<FormRef>(null);
  const amazonRef = useRef<FormRef>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  const [email, setEmail] = useState<string>("");
  const [cardNumber, setcardNumber] = useState<string>("");
  const [iconType, setIconType] = useState<string>("");
  const [selectedState, setSelectedState] = useState<any>(undefined);
  const [isDateErr, setIsDateErr] = useState<boolean>(false);
  const [bankName, setBankName] = useState<any>("");
  const [bank, setBank] = useState<any>("");
  const [errMsg, setErrMsg] = useState<string | undefined>(undefined);
  const [isRingLoading, setIsRingLoading] = useState<boolean>(false);
  const [numberNotmatchedError, setnumberNotmatchedError] =
    useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isErr, setIsErr] = useState(-1);
  const [cardErrMsg, setCardErrMsg] = useState("");
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [showButtons, setShowButtons] = useState<boolean>(false);
  const [tokenData, setTokenData] = useState<any>(null);
  const [isStaxPayPalLoading, setIsStaxPayPalLoading] =
    useState<boolean>(false);
  // Track if form has been modified
  const [isOneTimeDirty, setIsOneTimeDirty] = useState<boolean>(false);

  const scrollToDisclosure = () => {
    let parent = disclosureContainerRef.current?.parentElement;

    while (parent) {
      if (parent.scrollHeight > parent.clientHeight) {
        parent.scrollTo({ top: 0, behavior: "auto" });
      }
      parent = parent.parentElement;
    }

    if (disclosureContainerRef.current) {
      disclosureContainerRef.current.scrollIntoView({
        behavior: "auto",
        block: "start",
      });
      return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (showFinalDisclosure && pendingDisclosureScrollRef.current) {
      pendingDisclosureScrollRef.current = false;
      requestAnimationFrame(() => {
        scrollToDisclosure();
      });
      window.setTimeout(scrollToDisclosure, 100);
    }
  }, [showFinalDisclosure]);

  useEffect(() => {
    if (isAddNewCard) {
      let response = checkOldPaymentDetails({ dataPayment });
      setIsDisabled(response);
    } else {
      let response = checkNewPaymentDetails({
        values,
        cc_billing_address: portalSettings?.cc_billing_address,
        cc_billing_addr_mandatory: portalSettings?.cc_billing_addr_mandatory,
        selectedMethod,
        email,
        isErr,
        errMsg,
      });
      setIsDisabled(response);
    }
  }, [selectedMethod, values, email, isAddNewCard, dataPayment, isErr, errMsg]);

  useEffect(() => {
    if (schedulePayment) {
      setDataPayment({
        ...dataPayment,
        paymentValues: { ...values, iconType },
      });
    }
  }, [values]);

  const findBankByRoutingNumber = async (routingNumber: string) => {
    setIsRingLoading(true);
    try {
      let bankObj = await getBankName(routingNumber);
      if (bankObj?.type === "success") {
        setBankName(bankObj?.bank_name);
        setBank(bankObj?.bank_name);
        setValues((state: any) => ({
          ...state,
          bank_name: bankObj?.bank_name,
        }));
      } else {
        setErrMsg("Invalid routing number");
        setIsRingLoading(false);
      }
    } catch (error) {
      console.log("error =====", error);
      setErrMsg("Invalid routing number");
      setIsRingLoading(false);
    } finally {
      setIsRingLoading(false);
    }
  };

  const handleChangeCard = (e: any, name: string) => {
    if (name === "x_card_num") {
      let icon = getCardType(e.target.value) || iconType;
      if (icon === "amex") {
        if (e.target.value.length < 18) {
          const cardNumber = e.target.value.replace(/\s/g, "");
          const formattedCardNumber = cardNumber
            .replace(/\D/g, "")
            .replace(/(\d{4})(\d{6})(\d{5})/, "$1 $2 $3");
          setcardNumber(formattedCardNumber);
          setValues({ ...values, [name]: e.target.value });
        }
      } else {
        if (e.target.value.length < 20) {
          const cardNumber = e.target.value.replace(/\s/g, "");
          const formattedCardNumber = cardNumber
            .replace(/\D/g, "")
            .replace(/(\d{4})(?=\d)/g, "$1 ");
          setcardNumber(formattedCardNumber);
          setValues({ ...values, [name]: e.target.value });
        }
      }
    } else if (name === "x_card_code") {
      if (iconType === "amex") {
        if (e.target.value.length < 5) {
          setValues({ ...values, [name]: e.target.value });
        }
      } else {
        if (e.target.value.length < 4) {
          setValues({ ...values, [name]: e.target.value });
        }
      }
    } else if (name === "x_exp_date") {
      const inputValue = e.target.value;
      setIsDateErr(false);
      if (inputValue?.length < 6) {
        const isValidDate: any = expiryDateValidation(inputValue);
        const formattedDate = formatExpirationDate(inputValue);
        setValues({ ...values, [name]: formattedDate });
        !isValidDate?.isValid && inputValue?.length === 5 && setIsDateErr(true);
      }
    } else if (name === "x_country") {
      setValues({ ...values, [name]: e?.value });
    } else if (name === "x_state") {
      setValues({ ...values, [name]: e?.name });
    } else {
      setValues({ ...values, [name]: e.target.value });
    }
    // Mark form as dirty when user makes changes
    if (!isOneTimeDirty) {
      setIsOneTimeDirty(true);
    }
  };

  const handleChangeBank = (e: any, name: string) => {
    dispatch(setIsPaymentProcessing(true));
    if (name === "routing_number") {
      if (e.target.value.length < 10) {
        setValues({ ...values, [name]: e.target.value });
        setBankName("");
        setBank("");
        setErrMsg(undefined);
        if (e.target.value.length === 9) {
          findBankByRoutingNumber(e.target.value);
        }
      }
    } else if (name === "r_account_number") {
      setnumberNotmatchedError(false);
      setValues({ ...values, [name]: e.target.value });
      if (values?.account_number?.length === e.target.value?.length) {
        setnumberNotmatchedError(values?.account_number !== e.target.value);
      }
    } else {
      setValues({ ...values, [name]: e.target.value });
    }
    // Mark form as dirty when user makes changes
    if (!isOneTimeDirty) {
      setIsOneTimeDirty(true);
    }
  };

  useEffect(() => {
    setValues((state: any) => ({
      ...state,
      x_payment_method: getMethodCode(selectedMethod),
    }));
    if (schedulePayment) {
      setDataPayment({
        ...dataPayment,
        x_payment_method: getMethodCode(selectedMethod),
      });
    }
  }, [selectedMethod]);

  useEffect(() => {
    if (!cardNumber) {
      setIconType("");
      setValues({ ...values, card_type: "" });
      return;
    } else {
      setIconType(getCardType(cardNumber));
      setValues({ ...values, card_type: getCardType(cardNumber) });
    }
  }, [cardNumber]);

  const checkPastAmount = async (method?: string) => {
    try {
      let payload = {
        accounts_id: userData?.data?.accountData?.id,
        payment_method: method
          ? method
          : getMethod(isAddNewCard, dataPayment, selectedMethod),
        amount: editVal,
      };
      let res: any = await dispatch(duplicatePaymentGet(payload)).unwrap();
      const { isDuplicateOrders, duplicateOrdersCount } = res?.body?.data;
      if (isDuplicateOrders && duplicateOrdersCount > 0) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.log("error =====", error);
    }
  };

  const handleCheckDisclosureAndDuplicate = async (method?: string) => {
    try {
      let moveAhead = !checkedDuplicatePayment
        ? await checkPastAmount(method)
        : true;
      if (!moveAhead) {
        dispatch(onSetFinalDisclosureLoading(false));
        setIsLoading(false);
        return false;
      } else {
        if (
          (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
            portalSettings?.payment_agreement_opt === SettingsValue.DEFAULT) &&
          !showFinalDisclosure
        ) {
          setIsLoading(false);
          dispatch(resetDuplicateOrder());
          dispatch(onSetFinalDisclosureLoading(false));
          pendingDisclosureScrollRef.current = true;
          dispatch(onSetShowDisclosure(true));
        } else {
          dispatch(resetDuplicateOrder());
          dispatch(resetCheckDuplicatePayment());
          return true;
        }
      }
    } catch (error) {
      console.log("error =====", error);
    }
  };

  const handleOnSubmit = async () => {
    let negativeBalance = !checkAmount
      ? await checkOverPaymentAmount({
          amount: Number(editVal),
          balance: userData?.data?.accountData?.balance,
          overpayment_protection: portalSettings?.overpayment_protection,
          dispatch,
        })
      : true;
    if (!negativeBalance) {
      return;
    }

    setIsLoading(true);
    let moveAhead = await handleCheckDisclosureAndDuplicate();
    if (!moveAhead) {
      return;
    }
    dispatch(updateCheckAmountState(false));
    dispatch(setIsPaymentProcessing(true));
    try {
      let payload;
      if (!isAddNewCard) {
        payload = {
          ...values,
          x_payment_method: getMethodCode(selectedMethod),
          email,
          iconType,
          bankName,
          bank,
        };
      } else {
        let method = "CC";

        if (
          dataPayment?.selectedBank &&
          Object.keys(dataPayment.selectedBank).length > 0
        ) {
          method = "ACH";
        }
        if (
          dataPayment?.selectedWallet &&
          Object.keys(dataPayment.selectedWallet).length > 0
        ) {
          method = "WT";
        }

        let selectedData;
        if (method === "CC") {
          selectedData = dataPayment?.selectedCard;
        } else if (method === "WT") {
          selectedData = dataPayment?.selectedWallet;
          method = selectedData?.payment_method;
        } else {
          selectedData = dataPayment?.selectedBank;
        }

        payload = {
          x_payment_method: method,
          email: savedCardsEmail,
          x_card_num: selectedData?.cc_4digit,
          x_card_code: selectedData?.cc_cvv,
          x_exp_date: selectedData?.cc_expiry,
          iconType: selectedData?.cc_type,
          routing_number: selectedData?.routing_number,
          account_number: selectedData?.account_number,
          cc_token: selectedData?.cc_token,
          cc_token2: selectedData?.cc_token2,
          stripe_token: selectedData?.cc_token,
          bankName: selectedData?.bank_name,
          x_city: selectedData?.billing_city,
          x_address: selectedData?.billing_address,
          address2: selectedData?.billing_address2,
          x_zip: selectedData?.billing_zip,
          x_state: selectedData?.billing_state,
          x_country: selectedData?.billing_country,
          choldername: selectedData?.account_name,
          cppid: selectedData?.id,
        };
      }

      if (
        !isAddNewCard &&
        (selectedMethod === "Card" || selectedMethod === "Bank")
      ) {
        await createNewCard(payload);
      } else {
        await handleNext(payload);
      }

      setIsOneTimeDirty(false);
    } catch (error) {
      console.error("Error occurred:", error);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        dispatch(onSetFinalDisclosureLoading(false));
        dispatch(onSetShowDisclosure(false));
        dispatch(setIsPaymentProcessing(false));
      }, 500);
    }
  };

  const { showOverPaymentOverlay, checkAmount } = useAppSelector(
    (state: RootState) => state.common
  );

  const {
    paymentPermission,
    conFee,
    isFeeLoading,
    payPalOrder,
    isDuplicateOrders,
    duplicateOrdersCount,
    checkedDuplicatePayment,
  } = useAppSelector((state: RootState) => state.payment);

  useEffect(() => {
    if (isAddNewCard) {
      setShowButtons(true);
    } else {
      if (selectedMethod === "Card") {
        if (
          paymentPermission?.cc_gateway_name?.name === PaymentGateway.STRIPE ||
          paymentPermission?.cc_gateway_name?.name === PaymentGateway.STAX
        ) {
          setShowButtons(false);
        } else {
          setShowButtons(true);
        }
      } else if (selectedMethod === "Bank") {
        if (
          paymentPermission?.ach_gateway_name?.name === PaymentGateway.STRIPE ||
          paymentPermission?.ach_gateway_name?.name === PaymentGateway.STAX
        ) {
          setShowButtons(false);
        } else {
          let check = checkBankManualFormOrPlaid({
            manual_ach: portalSettings?.manual_ach,
            validate_bank_account: portalSettings?.validate_bank_account,
            isManualForm,
          });
          if (check) {
            setShowButtons(false);
          } else {
            setShowButtons(true);
          }
        }
      } else if (selectedMethod === "PayPal") {
        setShowButtons(false);
      } else if (selectedMethod === "Wire") {
        setShowButtons(true);
      } else if (selectedMethod === "Cash App Pay") {
        setShowButtons(false);
      } else if (selectedMethod === "Amazon Pay") {
        setShowButtons(false);
      } else if (selectedMethod === "Google Pay") {
        setShowButtons(false);
      } else if (selectedMethod === "Apple Pay") {
        setShowButtons(false);
      } else {
        setShowButtons(true);
      }
    }
  }, [
    selectedMethod,
    isAddNewCard,
    paymentPermission,
    isManualForm,
    portalSettings,
  ]);

  const getPaymentMethodPermission = async () => {
    try {
      let payload = {
        accountid: userData?.data?.accountData?.accountid,
        clusterid: clusterId,
        lead_id: accountLeadData?.lead_id,
      };
      await dispatch(getpaymentPermission(payload));
    } catch (error) {
      console.log("getPaymentMethodPermission error =====", error);
    }
  };

  const onOldCardDataGet = async () => {
    try {
      let payload = {
        accountid: userData?.data?.accountData?.accountid,
        accounts_id: userData?.data?.accountData?.id,
        cluster_id: clusterId,
      };
      await dispatch(oldPaymentMethodsGet(payload)).unwrap();
    } catch (error: any) {
      console.log("old card data get erro:-->", error?.message);
    }
  };

  useEffect(() => {
    if (isLogin && !schedulePayment) {
      onOldCardDataGet();
      getPaymentMethodPermission();
    }
  }, []);

  useDefaultPaymentMethodView({
    cardList,
    bankList,
    walletList,
    paymentMethodList,
    paymentPermission,
    isLogin,
    hasLoadedPaymentMethods,
    setShowSavedMethods: setIsAddNewCard,
    setDataPayment,
    selectedMethod,
    setSelectedMethod,
  });

  useEffect(() => {
    const method = getMethod(isAddNewCard, dataPayment, selectedMethod);
    let paymentMethodId = "";
    let custom_conv = "on";
    if (
      method === "CC" &&
      paymentPermission?.cc_gateway_name?.name === PaymentGateway.STAX &&
      isAddNewCard
    ) {
      paymentMethodId = dataPayment?.selectedCard?.cc_token;
    } else if (
      method === "ACH" &&
      paymentPermission?.ach_gateway_name?.name === PaymentGateway?.STAX &&
      isAddNewCard
    ) {
      paymentMethodId = dataPayment?.selectedBank?.cc_token;
    } else if (method === "PP") {
      custom_conv = "off";
    }

    if (isEdit || amtErr || !hasValidPaymentPrincipal(editVal)) {
      dispatch(resetConvFee());
      return;
    }

    const params = {
      cluster_id: clusterId,
      state:
        values?.x_state !== ""
          ? values?.x_state
          : userData?.data?.accountData?.state,
      x_method: method,
      phone_number: userData?.data?.accountData?.phone,
      x_amount: editVal,
      lead_id: accountLeadData?.lead_id,
      custom_conv,
      pm_id: paymentMethodId,
    };
    const feeRequest = dispatch(convFeeGet(params));

    feeRequest.unwrap().catch((error) => {
      if (error?.name !== "AbortError") {
        console.log("getConvFee error =====", error);
      }
    });

    return () => feeRequest.abort();
  }, [isEdit, editVal, selectedMethod, amtErr, isAddNewCard, dataPayment]);

  const handleAccept = async () => {
    dispatch(setIsPaymentProcessing(true));
    await dispatch(onSetFinalDisclosureLoading(true));
    try {
      if (isAddNewCard) {
        await handleOnSubmit();
      } else {
        switch (selectedMethod) {
          case "Card":
            if (
              paymentPermission?.cc_gateway_name?.name ===
                PaymentGateway.STRIPE &&
              cardRef.current
            ) {
              await cardRef.current.callHandleClick();
              // Reset form dirty state after successful submission
              setIsOneTimeDirty(false);
            } else {
              await handleOnSubmit();
            }
            break;
          case "Amazon Pay":
            if (amazonRef.current) {
              await amazonRef.current.callHandleClick();
              // Reset form dirty state after successful submission
              setIsOneTimeDirty(false);
            } else {
              await handleOnSubmit();
            }
            break;
          case "Bank":
            let check = checkBankManualFormOrPlaid({
              manual_ach: portalSettings?.manual_ach,
              validate_bank_account: portalSettings?.validate_bank_account,
              isManualForm,
            });
            if (
              (paymentPermission?.ach_gateway_name?.name ===
                PaymentGateway.STRIPE ||
                check) &&
              bankRef.current
            ) {
              await bankRef.current.callHandleClick();
              // Reset form dirty state after successful submission
              setIsOneTimeDirty(false);
            } else {
              await handleOnSubmit();
            }
            break;
          case "Cash App Pay":
            if (cashAppRef.current) {
              await cashAppRef.current.callHandleClick();
            }
            // Reset form dirty state after successful submission
            setIsOneTimeDirty(false);
            break;
          case "Wire":
            await handleOnSubmit();
            break;
          case "PayPal":
            if (
              (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
                portalSettings?.payment_agreement_opt ===
                  SettingsValue.DEFAULT) &&
              !showFinalDisclosure
            ) {
              setIsLoading(false);
              dispatch(resetDuplicateOrder());
              dispatch(onSetFinalDisclosureLoading(false));
              pendingDisclosureScrollRef.current = true;
              dispatch(onSetShowDisclosure(true));
            } else {
              dispatch(updateCheckAmountState(false));
              window.location.href = payPalOrder.url;
            }
            break;
          case "Google Pay":
            await handleGooglePayPayment(
              tokenData?.token,
              tokenData?.total_amount
            );
            break;
          default:
            console.log("selectedMethod =====", selectedMethod);
        }
      }
    } catch (error) {
      console.log("error =====", error);
      dispatch(setIsPaymentProcessing(false));
      await dispatch(onSetFinalDisclosureLoading(false));
      await dispatch(onSetShowDisclosure(false));
    }
  };

  const handlePlaidBankPayment = async (
    values: any,
    isCCTokenAvailable: boolean
  ): Promise<void> => {
    try {
      dispatch(setIsPaymentProcessing(true));
      let payload = {
        x_payment_method: "ACH",
        email: values?.email,
        bankName: values?.bankName,
        bank: values?.bank,
        choldername: values?.choldername,
        x_city: values?.x_city,
        x_address: values?.x_address,
        address2: values?.address2,
        x_zip: values?.x_zip,
        x_state: values?.x_state,
        x_country: values?.x_country,
        routing_number: values?.routing_number,
        account_number: values?.account_number,
        gateway_id: values?.gateway_id,
        gateway_name: values?.gateway_name,
        default: "N",
        cc_token: isCCTokenAvailable ? values?.cc_token : "",
        cc_token2: isCCTokenAvailable
          ? (values?.cc_token2 ?? values?.cc_token)
          : "",
        stripe_token: isCCTokenAvailable ? values?.stripe_token : "",
        pc_atid: values?.pc_atid,
        cppid: isCCTokenAvailable ? values?.cppid : 0,
      };
      if (isCCTokenAvailable) {
        await handleNext(payload);
      } else {
        await createNewCard(payload);
      }
      // Reset form dirty state after successful submission
      setIsOneTimeDirty(false);
    } catch (error) {
      console.log("handlePlaidBankPayment error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
    }
  };

  const handleGooglePayPayment = async (tokenData: any, amount: any) => {
    console.info("[Stripe Google Pay][one-time] payment received", {
      hasIntent: Boolean(tokenData?.id),
      intentType: tokenData?.id?.split("_")?.[0] || "legacy",
      paymentMethod: "GP",
    });
    setIsGoogleLoading(true);
    let negativeBalance = !checkAmount
      ? await checkOverPaymentAmount({
          amount: Number(editVal),
          balance: userData?.data?.accountData?.balance,
          overpayment_protection: portalSettings?.overpayment_protection,
          dispatch,
        })
      : true;
    if (!negativeBalance) {
      setIsGoogleLoading(false);
      return;
    }
    let moveAhead = !checkedDuplicatePayment
      ? await checkPastAmount("GP")
      : true;
    try {
      if (!moveAhead) {
        dispatch(onSetFinalDisclosureLoading(false));
        setSelectedMethod("Google Pay");
        setIsGoogleLoading(false);
        setTokenData({ token: tokenData, total_amount: amount });
      } else {
        if (
          (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
            portalSettings?.payment_agreement_opt === SettingsValue.DEFAULT) &&
          !showFinalDisclosure
        ) {
          setSelectedMethod("Google Pay");
          setTokenData({ token: tokenData, total_amount: amount });
          setIsGoogleLoading(false);
          dispatch(onSetFinalDisclosureLoading(false));
          dispatch(resetDuplicateOrder());
          pendingDisclosureScrollRef.current = true;
          dispatch(onSetShowDisclosure(true));
        } else {
          dispatch(resetDuplicateOrder());
          dispatch(resetCheckDuplicatePayment());
          dispatch(updateCheckAmountState(false));
          console.info("[Stripe Google Pay][one-time] forwarding payment", {
            hasIntent: Boolean(tokenData?.id),
            paymentMethod: "GP",
          });
          await handleGooglePay(tokenData, amount);
          // Reset form dirty state after successful submission
          setIsOneTimeDirty(false);
        }
      }
    } catch (error) {
      console.log("handleGooglePayPayment error =====", error);
    }
  };

  const markIncompleteOrder = async (orderId: number, error: any) => {
    try {
      if (orderId) {
        let res: any = await dispatch(
          markIncompletePayment({
            orderId,
            cluster_id:
              clusterId || userData?.data?.accountData?.clusterid,
            failed_reason: error.message,
          })
        ).unwrap();

        if (res?.body?.success) {
          setAmount(res?.body?.data?.amount + res?.body?.data?.cc_fee);
          let pay = {
            invoice_id: orderId,
            emails: [res?.body?.data?.email],
            isRealTime: true,
          };
          await sendEmail(pay);
        }
      }
      setFailedReason(error.message);
      setPaymentProcess("false");
    } catch (error) {
      console.log("markIncompleteOrder error ======", error);
    } finally {
      dispatch(resetDuplicateOrder());
      dispatch(resetCheckDuplicatePayment());
      dispatch(onSetShowDisclosure(false));
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(setIsPaymentProcessing(false));
    }
  };

  const verifyStripeCardPayment = async ({
    intent = null,
    error = null,
    email,
    orderId,
    principalAmount,
  }: VerifyStripeCardPaymentParams) => {
    if (error) {
      await markIncompleteOrder(orderId || 0, error);
    } else {
      try {
        dispatch(setIsPaymentProcessing(true));
        let payload = {
          lead_id: accountLeadData?.lead_id,
          cluster_id: userData?.data?.accountData?.clusterid,
          isrecurring: "N",
          x_payment_method: "CC",
          amount: principalAmount ?? parseFloat(editVal as string),
          accountid: userData?.data?.accountData?.accountid || "",
          first_name: userData?.data?.accountData?.first_name || "",
          last_name: userData?.data?.accountData?.last_name || "",
          phone_number: userData?.data?.accountData?.phone,
          module: "process_payment",
          transaction_id: intent || "",
          conv_fee: conFee,
          description: "Online Payment",
          payment_note: "One-time",
          email,
          incomplete_order_id: orderId,
          custom_conv: "on",
          ...offerPayload,
        };
        let res: any = await dispatch(verifyWalletPay(payload)).unwrap();
        if (res?.body?.success) {
          const { invoice_id } = res?.body?.data;
          setPaymentProcess("true");
          setEmailDisplay(res?.body?.data?.email);
          setAmount(res?.body?.data?.total_amount);
          setInvoiceId(invoice_id);

          if (!res?.body?.data?.isDuplicate) {
            await dispatch(
              addNotification({
                initiated_by: "contact",
                event_type: "payment_processed",
                userid: userData?.data?.accountData?.leadData?.user_id,
                email: res?.body?.data?.email,
                event_status: "succeeded",
                activity_type: "payment_activity",
                clusterid: clusterId,
                communication_status: "",
                accounts_id: userData?.data?.accountData?.id,
                payment_amount: res?.body?.data?.amount,
                order_id: invoice_id,
              })
            );
            let pay = {
              invoice_id,
              emails: [res?.body?.data?.email],
              isRealTime: true,
            };
            await sendEmail(pay);
          }
        } else {
          setFailedReason(res?.body?.data?.msg || res?.body?.data?.message);
          setPaymentProcess("false");
          let payment_amount = editVal;
          await dispatch(
            addNotification({
              initiated_by: "contact",
              event_type: "payment_processed",
              userid: userData?.data?.accountData?.leadData?.user_id,
              email: "",
              event_status: "failed",
              activity_type: "payment_activity",
              clusterid: clusterId,
              communication_status: "",
              accounts_id: userData?.data?.accountData?.id,
              payment_amount: res?.body?.data?.amount ?? payment_amount ?? 0,
              order_id: res?.body?.data?.invoice_id,
            })
          );
        }
      } catch (error: any) {
        setFailedReason("Payment failed");
        setPaymentProcess("false");
        console.log("verifyPay error =====", error);
      } finally {
        dispatch(resetDuplicateOrder());
        dispatch(resetCheckDuplicatePayment());
        dispatch(onSetShowDisclosure(false));
        dispatch(onSetFinalDisclosureLoading(false));
        dispatch(setIsPaymentProcessing(false));
      }
    }
  };

  const verifyStaxPayPal = async ({
    transactionId = "",
    error,
  }: {
    transactionId?: string;
    error?: any;
  }) => {
    setIsStaxPayPalLoading(true);
    try {
      dispatch(setIsPaymentProcessing(true));
      let payload = {
        lead_id: accountLeadData?.lead_id,
        clusterid: userData?.data?.accountData?.clusterid,
        isrecurring: "N",
        x_method: "PP",
        amount: parseFloat(editVal as string),
        customer_device: getOperatingSystem(),
        accountid: userData?.data?.accountData?.accountid || "",
        first_name: userData?.data?.accountData?.first_name || "",
        last_name: userData?.data?.accountData?.last_name || "",
        phone_number: userData?.data?.accountData?.phone,
        module: "process_payment",
        transaction_id: transactionId || "",
        conv_fee: conFee,
        description: "Online Payment",
        payment_note: "One-time",
        email,
        custom_conv: "on",
        start_date: new Date(),
        ...offerPayload,
      };
      let res: any = await dispatch(verifyPaymentsViaStax(payload)).unwrap();
      if (res?.body?.success) {
        const { invoice_id } = res?.body?.data;
        setPaymentProcess("true");
        setEmailDisplay(res?.body?.data?.email);
        setAmount(res?.body?.data?.amount);
        setInvoiceId(invoice_id);

        await dispatch(
          addNotification({
            initiated_by: "contact",
            event_type: "payment_processed",
            userid: userData?.data?.accountData?.leadData?.user_id,
            email: res?.body?.data?.email,
            event_status: "succeeded",
            activity_type: "payment_activity",
            clusterid: clusterId,
            communication_status: "",
            accounts_id: userData?.data?.accountData?.id,
            payment_amount: res?.body?.data?.amount,
            order_id: invoice_id,
          })
        );
        let pay = {
          invoice_id,
          emails: [res?.body?.data?.email],
          isRealTime: true,
        };
        await sendEmail(pay);
      } else {
        const { invoice_id } = res?.body?.data;
        let pay = {
          invoice_id,
          emails: [res?.body?.data?.email],
          isRealTime: true,
        };
        await sendEmail(pay);
        setInvoiceId(invoice_id);
        setAmount(res?.body?.data?.amount || payload?.amount);
        setFailedReason(res?.body?.data?.msg || res?.body?.data?.message);
        setPaymentProcess("false");
        let payment_amount = editVal;
        await dispatch(
          addNotification({
            initiated_by: "contact",
            event_type: "payment_processed",
            userid: userData?.data?.accountData?.leadData?.user_id,
            email: "",
            event_status: "failed",
            activity_type: "payment_activity",
            clusterid: clusterId,
            communication_status: "",
            accounts_id: userData?.data?.accountData?.id,
            payment_amount: res?.body?.data?.amount ?? payment_amount ?? 0,
            order_id: invoice_id,
          })
        );
      }
    } catch (error: any) {
      setFailedReason("Payment failed");
      setPaymentProcess("false");
      console.log("verifyPay error =====", error);
    } finally {
      setIsStaxPayPalLoading(false);
      dispatch(resetDuplicateOrder());
      dispatch(resetCheckDuplicatePayment());
      dispatch(onSetShowDisclosure(false));
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(setIsPaymentProcessing(false));
    }
  };

  const verifyStaxCardBank = async ({
    cc_token,
    cc_token2,
    x_method,
  }: VerifyStaxCardPaymentParams) => {
    try {
      dispatch(setIsPaymentProcessing(true));
      let payload = {
        lead_id: accountLeadData?.lead_id,
        clusterid: userData?.data?.accountData?.clusterid,
        isrecurring: "N",
        x_method: x_method,
        amount: parseFloat(editVal as string),
        customer_device: getOperatingSystem(),
        accountid: userData?.data?.accountData?.accountid || "",
        first_name: userData?.data?.accountData?.first_name || "",
        last_name: userData?.data?.accountData?.last_name || "",
        phone_number: userData?.data?.accountData?.phone,
        module: "process_payment",
        conv_fee: conFee,
        description: "Online Payment",
        payment_note: "One-time",
        email,
        custom_conv: "on",
        cc_token,
        cc_token2,
        ...offerPayload,
      };
      let res: any = await dispatch(verifyPaymentsViaStax(payload)).unwrap();
      if (res?.body?.success) {
        const { invoice_id } = res?.body?.data;
        setPaymentProcess("true");
        setEmailDisplay(res?.body?.data?.email);
        setAmount(
          res?.body?.data?.total_amount ||
            res?.body?.data?.amount ||
            payload.amount
        );
        setInvoiceId(invoice_id);

        await dispatch(
          addNotification({
            initiated_by: "contact",
            event_type: "payment_processed",
            userid: userData?.data?.accountData?.leadData?.user_id,
            email: res?.body?.data?.email,
            event_status: "succeeded",
            activity_type: "payment_activity",
            clusterid: clusterId,
            communication_status: "",
            accounts_id: userData?.data?.accountData?.id,
            payment_amount:
              res?.body?.data?.total_amount ||
              res?.body?.data?.amount ||
              payload.amount,
            order_id: invoice_id,
          })
        );
        let pay = {
          invoice_id,
          emails: [res?.body?.data?.email],
          isRealTime: true,
        };
        await sendEmail(pay);
      } else {
        const { invoice_id } = res?.body?.data;
        let pay = {
          invoice_id,
          emails: [res?.body?.data?.email],
          isRealTime: true,
        };
        await sendEmail(pay);
        setInvoiceId(invoice_id);
        setAmount(res?.body?.data?.amount || payload?.amount);
        setFailedReason(res?.body?.data?.msg || res?.body?.data?.message);
        setPaymentProcess("false");
        let payment_amount = editVal;
        await dispatch(
          addNotification({
            initiated_by: "contact",
            event_type: "payment_processed",
            userid: userData?.data?.accountData?.leadData?.user_id,
            email: "",
            event_status: "failed",
            activity_type: "payment_activity",
            clusterid: clusterId,
            communication_status: "",
            accounts_id: userData?.data?.accountData?.id,
            payment_amount:
              res?.body?.data?.total_amount ||
              res?.body?.data?.amount ||
              payment_amount ||
              0,
            order_id: res?.body?.data?.invoice_id,
          })
        );
      }

      return res;
    } catch (error: any) {
      setFailedReason("Payment failed");
      setPaymentProcess("false");
      console.log("verifyPay error =====", error);
    } finally {
      setIsStaxPayPalLoading(false);
      dispatch(resetDuplicateOrder());
      dispatch(resetCheckDuplicatePayment());
      dispatch(onSetShowDisclosure(false));
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(setIsPaymentProcessing(false));
    }
  };

  return (
    <>
      <div
        className={`${
          !schedulePayment ? "lg:px-10 px-5" : ""
        } ${showFinalDisclosure ? `hidden none` : ""}`}
      >
        <div
          className={`${schedulePayment ? "" : "lg:pt-[100px] max-w-[510px] w-full mx-auto"} pb-9`}
        >
          <div
            className={`lg:max-w-[510px] flex flex-col lg:gap-10 gap-5 text-LightTextParagraph mt-2 lg:w-[98%]`}
          >
            {isAddNewCard ? (
              <>
                <div>
                  {isPaymentLink && (
                    <div className="flex justify-between items-center mb-5">
                      <p className="lg:text-xl text-base font-medium text-txtPrimary">
                        Payment method
                      </p>

                      <p
                        onClick={() => {
                          dispatch(setIsPaymentProcessing(true));
                          setIsAddNewCard(false);
                        }}
                        className="flex gap-2 items-center cursor-pointer xl:text-sm text-xs  font-medium text-blue hover:!text-btnPrimaryHover"
                      >
                        <AddCircleIconBlue /> Add New
                      </p>
                    </div>
                  )}

                  <PaymentProcessStep2
                    data={dataPayment}
                    setData={setDataPayment}
                    setCurrentStep={setCurrentStep}
                    isDataLoading={isDataLoading}
                    currentStep={currentStep}
                    walletList={walletList}
                    setSavedCardsEmail={setSavedCardsEmail}
                    isPaymentLink={isPaymentLink}
                    setShowPreview={setShowPreview}
                    paymentMethodList={paymentMethodList}
                    setSelectedMethod={setSelectedMethod}
                    amount={editVal}
                  />
                </div>
              </>
            ) : (
              <PaymentMethodsComponent
                cardData={{
                  cardNumber,
                  isDateErr,
                  isErr,
                  cardErrMsg,
                  handleChangeCard,
                  validateCard: () =>
                    validateCard({
                      values,
                      iconType,
                      setIsErr,
                      setCardErrMsg,
                      setErrMsg,
                    }),
                  iconType,
                  setIconType,
                  setIsAddNewCardMakePayment: setIsAddNewCard,
                  isAddNewCardMakePayment: isAddNewCard,
                  showNewStripeCardForm: true,
                }}
                bankData={{
                  bankName,
                  numberNotmatchedError,
                  setnumberNotmatchedError,
                  handleChangeBank,
                  selectedState,
                  setSelectedState,
                  stripeBankURL: `${window.location.href}?pay=one_time&method=bank&amount=${editVal}&isRecurring=${schedulePayment}${offerCallbackQuery}`,
                  isManualForm,
                  setIsManualForm,
                  handlePlaidBankPayment,
                  checkNegativeBalance: true,
                }}
                paymentConfig={{
                  paymentMethodList,
                  selectedMethod,
                  setSelectedMethod,
                  amount: editVal,
                  isRecurring: schedulePayment,
                  isPaymentLink,
                  isEdit,
                  isUpdatePlan,
                  isSchedulePayment: schedulePayment,
                  dataArr,
                  isStaxPayPalLoading,
                  useStripeGooglePay: true,
                  useStripeApplePay: !schedulePayment,
                }}
                paymentHandlers={{
                  handleGooglePay: (tokenData: any, amount: any) => {
                    handleGooglePayPayment(tokenData, amount);
                  },
                  verifyStaxPayPal,
                  verifyStaxCardBank,
                  createPayPalIntent,
                  handleApplePay,
                  handleBack: handlePrev,
                  setShowPreview,
                  verifyStripeCardPayment,
                }}
                paymentUrls={{
                  cashAppURL: `${window.location.href}?pay=one_time&method=cashapp&amount=${editVal}&isRecurring=${schedulePayment}${offerCallbackQuery}`,
                  stripeAmazonPayURL: `${window.location.href}?pay=one_time&method=amazonPay&amount=${editVal}&isRecurring=${schedulePayment}${offerCallbackQuery}`,
                }}
                formState={{
                  values,
                  email,
                  setEmail: (val: string) => {
                    setEmail(val);
                    if (!isOneTimeDirty) {
                      setIsOneTimeDirty(true);
                    }
                  },
                  errMsg,
                  amtErr,
                  setAmtErr,
                  isRingLoading,
                }}
                paymentGatewayState={{
                  isGoogleLoading,
                  disableInputFields: isLoading || isGoogleLoading,
                }}
                componentRefs={{
                  cashAppRef,
                  bankRef,
                  cardRef,
                  amazonRef,
                }}
                phoneAndAddressConfig={{}}
                description={"One-time"}
              />
            )}

            <div className="w-full">
              {!schedulePayment
                ? showButtons && (
                    <>
                      <Button
                        text={`
                      Pay ${
                        formatCurrency(
                          getPaymentTotalWithFee(
                            offerAmount && parseInt(offerAmount) > 0
                              ? offerAmount
                              : editVal,
                            conFee
                          )
                        ) || "$0.00"
                      }
                    `}
                        className={`w-full`}
                        isDisabled={
                          editVal === "0.00" ||
                          (amtErr ? true : false) ||
                          isDisabled ||
                          isEdit ||
                          isFeeLoading ||
                          numberNotmatchedError ||
                          (selectedMethod === "Bank" && isRingLoading)
                        }
                        isLoading={isLoading || isFeeLoading}
                        onClick={() => {
                          handleOnSubmit();
                        }}
                        variant="variable"
                      />
                    </>
                  )
                : null}
            </div>
          </div>
        </div>
      </div>

      <div
        ref={disclosureContainerRef}
        className={`h-full lg:max-h-[var(--shell-vh)] relative content w-full lg:pt-20 lg:pb-[40px] md:p-10 p-5 max-w-[740px] mx-auto ${
          !showFinalDisclosure ? `hidden none` : ""
        }`}
        style={{ scrollMarginTop: "84px" }}
      >
        <DisclosureFinal
          generalMarkers={generalMarkers}
          handleAccept={handleAccept}
          isOpen={showFinalDisclosure}
        />
      </div>
      <CustomModal
        signModal={false}
        isLoading={false}
        isOpen={isDuplicateOrders && duplicateOrdersCount > 0}
        title="Alert"
        doneText="Complete Payment"
        className="max-w-[600px] w-full h-fit rounded-[10px]"
        cancleText="Cancel"
        onDoneClick={() => {
          dispatch(resetDuplicateOrder());
          handleAccept();
        }}
        onCloseClick={() => {
          dispatch(resetCheckDuplicatePayment());
          dispatch(resetDuplicateOrder());
        }}
        children={
          <React.Fragment>
            <div className="pt-5 lg:text-xl text-txtPrimary lg:leading-[30px] leading-[24px]">
              A similar payment was made in the last 10 minutes. Click 'Complete
              Payment' if this is not a duplicate.
            </div>
          </React.Fragment>
        }
      />

      <CustomModal
        signModal={false}
        isLoading={false}
        isOpen={showOverPaymentOverlay}
        title="Alert"
        doneText="Proceed"
        className="max-w-[600px] w-full h-fit rounded-[10px]"
        cancleText="Cancel"
        hasDoneButton={
          portalSettings?.overpayment_protection ===
          OverPaymentProtectionEnum.ALERT
        }
        onDoneClick={() => {
          dispatch(updateShowOverlayState(false));
          handleAccept();
        }}
        onCloseClick={() => {
          dispatch(updateCheckAmountState(false));
          dispatch(updateShowOverlayState(false));
        }}
        children={
          <React.Fragment>
            <div className="pt-5 lg:text-xl text-txtPrimary lg:leading-[30px] leading-[24px]">
              Processing this payment will result in a negative balance on your
              account. Please review the payment amount.
            </div>
          </React.Fragment>
        }
      />
    </>
  );
};

export default OneTimePayment;
